import { Model } from '@appstrax/services/database';

export class ContactMessage extends Model {
  public topic: string = '';
  public name: string = '';
  public email: string = '';
  public organization?: string;
  public subject: string = '';
  public message: string = '';
  public consent: boolean = false;

  // Optional context
  public projectId?: string;
  public organizationId?: string;
}

